import { otherApiClient } from "./index";
export const getPackage = async (id)=>{
    const { data  } = await otherApiClient.market("/packages/".concat(id));
    return data;
};
